import { notification } from 'antd'
import apiClient from '../index'

export const addTeam = async (data) => {
  try {
    const response = await apiClient.post('teams/addTeam', data)
    return response.data
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const assignEmp = async (data) => {
  try {
    const response = await apiClient.post('teams/assignEmp', data)
    return response.data
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getTeamsHierarchy = async ({ depId, process, locationId }) => {
  try {
    return await apiClient.get('teams/getTeamsHierarchy', {
      params: {
        depId,
        process,
        locationId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    return null
  }
}
export const getHierarchyForAgent = async ({ amId, managerId, tlId }) => {
  try {
    return await apiClient.get('teams/getHierarchyForAgent', {
      params: {
        amId,
        managerId,
        tlId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    return null
  }
}

export const getTeamData = async (params) => {
  const { skip, limit, searchedTeam, isActive, depId } = params
  try {
    const response = await apiClient.get('teams/getAllTeams', {
      params: {
        skip,
        limit,
        searchedTeam,
        isActive,
        depId,
      },
    })

    return response
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    return null
  }
}

export const getTeamDetails = async (id) => {
  try {
    return await apiClient.get(`teams/getTeamDetails/${id}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    return null
  }
}

export const updatedteam = async (data, id) => {
  try {
    return await apiClient.patch(`teams/updateteam/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getLeadershipChangeRequests = () => apiClient.get('teams/leadership-change-requests')

export const approveLeadershipChangeRequest = (id, data = {}) =>
  apiClient.patch(`teams/leadership-change-requests/${id}/approve`, data)

export const rejectLeadershipChangeRequest = (id, data) =>
  apiClient.patch(`teams/leadership-change-requests/${id}/reject`, data)
